module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/totes/totes.component.html
// module id = 892
// module chunks = 4